import { FundingType } from '@bytel/leviator';

import { DiscountEnumType } from '@app-types/discount';
import { IFundingDetail } from '@app-types/funding';
import { MobilePlanType } from '@app-types/plan';

export function getFundingPhone(product: MobilePlanType, phoneGencode: string): IFundingDetail[] {
    if (!product?.simulatedCart?.quotes[0]?.products) return [];

    const phone = product.simulatedCart.quotes[0]?.products.find((el) => el.gencode === phoneGencode);
    const fundings = phone?.details.fundings ?? [];
    const promotionODR = phone?.details.discounts.filter((promo) => promo.type === DiscountEnumType.ODR)[0]?.value ?? 0;

    if (fundings.length === 0) return [];

    return fundings.map((funding) => ({
        ...funding,
        initialContributionWithOdr:
            promotionODR > 0 ? Math.max(funding.initialDeposit - promotionODR, 1) : funding.initialDeposit,
    }));
}

export function getFundingOrder(type: FundingType): number {
    switch (type) {
        case FundingType.EDP:
            return 1;
        case FundingType.COMPTANT:
            return 2;
        default:
            return 0;
    }
}

export function getDefaultFunding(fundings: IFundingDetail[], presetValue?: string | null): IFundingDetail | undefined {
    return fundings?.find((funding) => (presetValue ? funding.key === presetValue : funding.favorite)) ?? fundings[0];
}
